
import {Component, Vue, Prop} from 'vue-property-decorator';
import ServiceContainer from '@flashpointbv/solar-service-container';
import {SolarDataLayer} from '@flashpointbv/solar-datalayer/dist';

@Component({
  name: 'catalog-product-list',
  components: ServiceContainer().getComponents(),
})
export default class extends Vue {
  @Prop({required: true}) readonly dataSource: string;
  @Prop({default: 4}) private chunkSize: number;
  @Prop({default: () => []}) private wishlistItems: Array<object>;
  @Prop() private bannerData: object;

  private get isLoading(): boolean {
    return this.$store.getters[`${this.dataSource}/isLoading`];
  }

  private get products(): Array<object> {
    return this.$store.getters[`${this.dataSource}/productList`];
  }

  private updated(): void {
    this.$nextTick(() => {
      const productPlaceholder = document.querySelector('.catalog__category-list .category__placeholder');
      if (productPlaceholder) {
        (productPlaceholder as HTMLElement).style.display = 'none';
      }

      this.normalizeRowHeights('.product__name__holder', this.getItemsAtViewportCategory());
      this.normalizeRowHeights('.product__category', this.getItemsAtViewportCategory());
      this.normalizeRowHeights('.product__usp', this.getItemsAtViewportCategory());
    });
  }

  private created(): void {
    SolarDataLayer.init().addViewItemsList(this.products, 'Product list');
  }

  private getItemsAtViewportCategory(): number {
    const width = window.innerWidth;

    if (width >= 576 && width < 768) {
      return 1;
    } else if (width >= 768 && width < 992) {
      return 2;
    } else {
      return 4;
    }
  }

private normalizeRowHeights(selector, itemsPerRow) : void {
    console.log('normalizeRowHeights');
    const elements = document.querySelectorAll(selector);
    const totalItems = elements.length;

    // Reset eventuele eerdere hoogte-instellingen
    elements.forEach(el => {
      el.style.height = 'auto';
    });

    for (let i = 0; i < totalItems; i += itemsPerRow) {
      const rowItems = Array.from(elements).slice(i, i + itemsPerRow);

      // Bepaal de hoogste hoogte in deze rij
      const maxHeight = Math.max(...rowItems.map(el => el.offsetHeight));

      // Pas de hoogste hoogte toe op alle elementen in deze rij
      rowItems.forEach(el => {
        el.style.height = `${maxHeight}px`;
      });
    }
  }
}
